/* READ MORE FUNCTIONALITY */
document.addEventListener('DOMContentLoaded', function() {
    var maxHeight = 160; // Set your desired height limit here
    var descriptions = document.querySelectorAll('.product__description .rte');

    var readMoreButton = document.getElementById('description__readMore');
    var productDescription = document.querySelector('.product__description');

    var readMoreButton = document.getElementById('description__readMore');
    var productDescription = document.querySelector('.product__description');

    if (readMoreButton && productDescription) {
        readMoreButton.addEventListener('click', function() {
            // Toggle the 'shortened' class on the product description
            productDescription.classList.toggle('shortened');

            // Optional: Change the button text based on the toggle state
            if (productDescription.classList.contains('shortened')) {
                readMoreButton.textContent = 'Read More'; // Change to "Read More" when shortened
            } else {
                readMoreButton.textContent = 'Read Less'; // Change to "Read Less" when expanded
            }
        });
    }
    setTimeout(function() {
          descriptions.forEach(function(rte) {
              if (rte.offsetHeight > maxHeight) {
                  var productDescription = rte.closest('.product__description');
                  
                  if (productDescription) {
                      productDescription.classList.add('shortened'); // Add 'shortened' class to the parent
                  }
              } else {
                      readMoreButton.className = "hidden"
                  }
          });
    }, 100);
});
